<template>
  <div class="empty">
    <h1>This is an Empty page {{componentName}}</h1>
  </div>
</template>

<script>
export default {
  props:['name'],
  data(){
    return{
      componentName: this.name
    }
  }
};
</script>
